import { render, staticRenderFns } from "./IngredientView.vue?vue&type=template&id=0fddcea8&"
import script from "./IngredientView.vue?vue&type=script&lang=js&"
export * from "./IngredientView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports